// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/ignorance-board/ignorance-board.component.css
// module id = 755
// module chunks = 0